import { useNuxtApp } from "#app";

export const useAnalytics = () => {
  return useNuxtApp().$analytics;
};
